import React, { useState } from "react";
import { UserPlus, UserCog, KeyRound, UserX, UserCheck } from "lucide-react";
import FormTemplate from "@/components/templates/FormTemplate";
import UserCreationForm from "@/components/organisms/UserCreationForm";
import UserEditForm from "@/components/organisms/UserEditForm";
import UserDisableForm from "@/components/organisms/UserDisableForm";
import UserEnableForm from "@/components/organisms/UserEnableForm";
import UserPasswordForm from "@/components/organisms/UserPasswordForm";

function UserManagement() {
  const [activeTab, setActiveTab] = useState("create");

  const tabs = [
    { id: "create", label: "Create User", icon: UserPlus },
    { id: "edit", label: "Edit User", icon: UserCog },
    { id: "disable", label: "Disable User", icon: UserX },
    { id: "enable", label: "Enable User", icon: UserCheck },
    { id: "password", label: "Reset Password", icon: KeyRound },
  ];

  return (
    <FormTemplate title="User Management">
      <div className="space-y-6">
        {/* Tabs */}
        <div className="border-b border-gray-200">
          <nav className="flex space-x-4" aria-label="Tabs">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`
                  py-4 px-1 border-b-2 font-medium text-sm flex items-center space-x-2
                  transition-colors duration-200 whitespace-nowrap
                  ${
                    activeTab === tab.id
                      ? "border-orange-500 text-orange-600"
                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                  }
                `}
              >
                <span className="text-lg"><tab.icon size={18} /></span>
                <span>{tab.label}</span>
              </button>
            ))}
          </nav>
        </div>

        {/* Tab Content */}
        <div className="mt-6">
          {activeTab === "create" && <UserCreationForm />}
          {activeTab === "edit" && <UserEditForm />}
          {activeTab === "disable" && <UserDisableForm />}
          {activeTab === "enable" && <UserEnableForm />}
          {activeTab === "password" && <UserPasswordForm />}
        </div>
      </div>
    </FormTemplate>
  );
}

export default UserManagement;
